import { useSyncExternalStore } from 'react'
import { draftWritesInFlight, subscribeToDraftWrites } from '@/api/draftWrites'

// How many draft writes from this tab are still waiting for the server
// (api/draftWrites.ts).
export function useDraftWritesInFlight(): number {
  return useSyncExternalStore(subscribeToDraftWrites, draftWritesInFlight)
}
